<template>
  <div class="yx-statistics-jxf-page main-layout">
    <!-- <BackToPrePage /> -->
    <CCollapseItem>
      <template slot="title-left">
        <span
          class="title title-breadcrumb"
          @click="$router.push('/welcome/statistics/scene')"
        >
          <i
            class="iconfont icon-fanhui"
            style="font-size: 20px; margin-right: 5px"
          ></i>
          <span>现场报到统计</span>
        </span>
      </template>
      <template slot="title-center">
        <span
          :title="title"
          class="sub-title ellipsis"
          style="width: 100px; text-align: center"
          >{{ title }}</span
        >
      </template>
      <template slot="body">
        <c-search
          v-model="pageParams"
          :searchItems="searchItems"
          @reset="refresh"
          @search="pageGet(true)"
        >
        </c-search>
      </template>
    </CCollapseItem>
    <el-card class="box-table box-bottom">
      <div slot="header" class="btn-group">
        <!-- 操作按钮 -->
        <div class="btn-left">
          <div class="opt-btn" title="导出" @click="exportExcel">
            <i
              class="iconfont icon-daochu3"
              :class="{ disabled: isExport }"
            ></i>
          </div>
        </div>
        <!-- 右侧操作按钮 -->
        <table-btns
          :tableColumns="tableColumns"
          @tableColumnsChange="tableColumnsChange"
          @refresh="
            idList = [];
            pageGet(true);
          "
        ></table-btns>
      </div>

      <c-table
        :data="pageData"
        :tableColumns="tableColumns"
        :pagination="pageParams"
        @change="pageGet"
        @selectionChange="selectionChange"
        v-loading="pageLoading"
      >
      </c-table>
    </el-card>
  </div>
</template>
 
<script>
import MPage from "@/mixins/MPage.js";
import Configs from "./data/sceneItem";
import { getOrgOptions } from "@/libs/searchSelect.js";
import { mapState } from "vuex";
let mPage = MPage({
  pagePath: "/welcome-live/statistics/oneLinkListPage",
  pageDelPath: "",
  pageDelsPath: "",
  pageParams: {
    idCard: "",
    studentName: "",
    link: "",
    status: "",
    collegeId: "",
    grade: "",
    majorId: "",
    classId: "",
    classIdList: [],
    linkId: "",
    academicDegree: "",
    studentNoOrName: "",
    sex: "",
  },
  pageExportPath: "/welcome-live/statistics/exportExcel/oneLink",
  pageExportParams: {},
});
export default {
  mixins: [mPage],
  data() {
    let { searchItems, tableColumns } = Configs(this);
    return {
      isFold: false,
      searchItems,
      tableColumns,
      isExport: false,
      idList: [],
      title: "",
    };
  },
  computed: {
    ...mapState("dic", [
      "SUCCESS_CODE",
      "_CURRENTYEAR",
      "_COLLEGE_ID",
      "_CURRENT_ACADEMIC",
    ]),
  },
  created() {
    this.setCollegeId();
    this.linkId = this.$route.params.linkId;
    this.title = this.$route.params.title;
    this.pageParams.linkId = this.linkId;
  },
  mounted() {},
  methods: {
    setCollegeId() {
      if (this._COLLEGE_ID) {
        this.pageParams.collegeId = this._COLLEGE_ID;
        getOrgOptions(
          this,
          { parentId: this._COLLEGE_ID, type: "department" },
          1,
          null
        );
      }
    },
    selectionChange(data) {
      let idList = [];
      if (data.length) {
        data.forEach((item) => {
          idList.push(item.studentId);
        });
        this.idList = idList;
      }
    },
    handleDelBatch() {
      if (this.idList.length) {
        this.pageDels(this.idList);
      } else {
        this.$message({
          message: "请选择需要删除的数据！",
          type: "warning",
        });
      }
    },
    pageDelAfterFn() {
      this.idList = [];
      this.pageGet(true);
    },
    pageGetBeforeFn(data) {
      let params = Object.assign({}, data);
      if (!params.academicDegree)
        params.academicDegree = this._CURRENT_ACADEMIC;
      params.enrollmentYear = this._CURRENTYEAR[0].value;
      params.classId = params.classIdList.join(",");
      delete params.classIdList;
      return params;
    },
    refresh() {
      this.idList = [];
      this.searchItems[2].options = [];
      this.searchItems[3].options = [];
      this.pageParams = {
        idCard: "",
        studentName: "",
        link: "",
        status: "",
        collegeId: "",
        grade: "",
        majorId: "",
        classId: "",
        classIdList: [],
        linkId: this.linkId,
        academicDegree: "",
        studentNoOrName: "",
        sex: "",
      };
      this.setCollegeId();
      this.pageGet(true);
    },
    tableColumnsChange(data) {
      let self = this;
      self.tableColumns.forEach((item) => {
        if (data.indexOf(item.prop) == -1) {
          item.show = false;
        } else {
          item.show = true;
        }
      });
    },
    exportExcel() {
      if (this.isExport) {
        return;
      } else {
        this.isExport = true;
        this.message = this.$message({
          message: "数据正在导出中，请稍候！",
          duration: 0,
          type: "warning",
          center: true,
        });
        let params = Object.assign({}, this.pageParams);
        if (!params.academicDegree)
          params.academicDegree = this._CURRENT_ACADEMIC;
        params.enrollmentYear = this._CURRENTYEAR[0].value;
        this.pageExportParams = params;
        if (this.idList.length) {
          this.pageExportParams.studentIdStr = this.idList.join();
        }
        this.pageExportParams.classId =
          this.pageExportParams.classIdList.join(",");
        delete this.pageExportParams.classIdList;
        this.pageExport();
      }
    },
    pageExportAfterFn() {
      this.isExport = false;
      this.message.close();
      this.message = null;
      this.refresh();
      this.pageExportParams = {};
    },
  },
};
</script>